<script setup>


import { parseHeziyunData } from '@/utils/heziyunData' // 解析数据


const HeziyunData = ref(parseHeziyunData().global)

console.log(HeziyunData.value)


</script>

<template>


    <!-- banner图 -->
    <div class="Heziyun-banners">
        <div class="masthead segment"></div>
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-banner-title">
                <span class="btn-shine" v-intersect="{ class: 'bottom-top', delay: 0 }">{{
                    $t('finance.bannerTitle') }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 200 }">
                    {{ $t('finance.bannerDesc') }}
                </p>
                <div class="Heziyun-buttonArray">
                    <a href="/home.htm" class="Ui-Btn" v-intersect="{ class: 'bottom-top', delay: 300 }">{{
                        $t('finance.freeConsultation') }}</a>
                </div>
            </div>
        </div>
    </div>


    <!-- 服务优势 -->
    <div class="Heziyun-serviceAdvantages Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('finance.advantagesTitle')
                }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{ $t('finance.advantagesSubtitle')
                }}</p>
            </div>
            <div class="Heziyun-advantage">
                <div class="Heziyun-itemSolve" v-intersect="{ class: 'bottom-top', delay: 200 }">
                    <div class="Heziyun-photo">
                        <img src="@/static/img/solution/finance/itemSolve1.png" alt="">
                    </div>
                    <div class="Heziyun-title">
                        <span>{{ $t('finance.advantage1Title') }}</span>
                        <p>{{ $t('finance.advantage1Desc') }}</p>
                    </div>
                </div>
                <div class="Heziyun-itemSolve" v-intersect="{ class: 'bottom-top', delay: 300 }">
                    <div class="Heziyun-photo"><img src="@/static/img/solution/finance/itemSolve2.png" alt="">
                    </div>
                    <div class="Heziyun-title">
                        <span>{{ $t('finance.advantage2Title') }}</span>
                        <p>{{ $t('finance.advantage2Desc') }}</p>
                    </div>
                </div>
                <div class="Heziyun-itemSolve" v-intersect="{ class: 'bottom-top', delay: 400 }">
                    <div class="Heziyun-photo"><img src="@/static/img/solution/finance/itemSolve3.png" alt="">
                    </div>
                    <div class="Heziyun-title">
                        <span>{{ $t('finance.advantage3Title') }}</span>
                        <p>{{ $t('finance.advantage3Desc') }}</p>
                    </div>
                </div>
                <div class="Heziyun-itemSolve" v-intersect="{ class: 'bottom-top', delay: 500 }">
                    <div class="Heziyun-photo"><img src="@/static/img/solution/finance/itemSolve4.png" alt="">
                    </div>
                    <div class="Heziyun-title">
                        <span>{{ $t('finance.advantage4Title') }}</span>
                        <p>{{ $t('finance.advantage4Desc') }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 解决方案架构 -->
    <div class="Heziyun-framework Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('finance.architectureTitle')
                }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{
                    $t('finance.architectureSubtitle') }}</p>
            </div>
            <div class="Heziyun-structure">
                <div class="Heziyun-purePhoto" v-intersect="{ class: 'left-right', delay: 200 }">
                    <img src="@/static/img/solution/finance/back.png" alt="">
                </div>
                <div class="Heziyun-sketch" v-intersect="{ class: 'right-left', delay: 200 }">
                    <div class="Heziyun-titleStructure">{{ $t('finance.architectureDescTitle') }}</div>
                    <div class="Heziyun-describe">{{ $t('finance.architectureDesc') }}</div>
                    <div class="Heziyun-whole">
                        <div class="Heziyun-itemMatch">
                            <img src="@/static/img/solution/website/checkMark.svg" alt="">
                            <p>{{ $t('finance.architectureFeature1') }}</p>
                        </div>
                        <div class="Heziyun-itemMatch">
                            <img src="@/static/img/solution/website/checkMark.svg" alt="">
                            <p>{{ $t('finance.architectureFeature2') }}</p>
                        </div>
                        <div class="Heziyun-itemMatch">
                            <img src="@/static/img/solution/website/checkMark.svg" alt="">
                            <p>{{ $t('finance.architectureFeature3') }}</p>
                        </div>
                        <div class="Heziyun-itemMatch">
                            <img src="@/static/img/solution/website/checkMark.svg" alt="">
                            <p>{{ $t('finance.architectureFeature4') }}</p>
                        </div>
                    </div>
                    <a href="/home.htm">{{ $t('finance.learnMore') }}</a>
                </div>
            </div>
        </div>
    </div>

    <!-- 行业痛点 -->
    <div class="Heziyun-painPoints Heziyun-padding">
        <div class="Heziyun-defaultWidth">
            <div class="Heziyun-commodity-title">
                <span v-intersect="{ class: 'bottom-top', delay: 0 }">{{ $t('finance.painPointsTitle')
                }}</span>
                <p v-intersect="{ class: 'bottom-top', delay: 100 }">{{ $t('finance.painPointsSubtitle')
                }}</p>
            </div>
            <div class="Heziyun-painPoints-list">
                <div class="Heziyun-item" v-intersect="{ class: 'bottom-top', delay: 0 }">
                    <img src="@/static/img/solution/ecommerce/itemNucleus1.png" alt="">
                    <span>{{ $t('finance.painPoint1Title') }}</span>
                    <p>{{ $t('finance.painPoint1Desc') }}</p>
                </div>
                <div class="Heziyun-item" v-intersect="{ class: 'bottom-top', delay: 50 }">
                    <img src="@/static/img/solution/ecommerce/itemNucleus2.png" alt="">
                    <span>{{ $t('finance.painPoint2Title') }}</span>
                    <p>{{ $t('finance.painPoint2Desc') }}</p>
                </div>
                <div class="Heziyun-item" v-intersect="{ class: 'bottom-top', delay: 100 }">
                    <img src="@/static/img/solution/ecommerce/itemNucleus3.png" alt="">
                    <span>{{ $t('finance.painPoint3Title') }}</span>
                    <p>{{ $t('finance.painPoint3Desc') }}</p>
                </div>
                <div class="Heziyun-item" v-intersect="{ class: 'bottom-top', delay: 150 }">
                    <img src="@/static/img/solution/ecommerce/itemNucleus4.png" alt="">
                    <span>{{ $t('finance.painPoint4Title') }}</span>
                    <p>{{ $t('finance.painPoint4Desc') }}</p>
                </div>
            </div>
        </div>
    </div>


</template>

<style>
@import "@/static/css/import";
@import "@/static/font/font.css";

body {
    background-color: #f5f7fc;
}
</style>

<style lang="less" scoped>
// banner图
.Heziyun-banners {
    background: url('../../static/img/solution/finance/banner.png') no-repeat center;
    background-size: cover;
    position: relative;
    height: 20rem;
    margin-top: 3.6rem;
    padding: 0;

    .Heziyun-defaultWidth {
        position: relative;
        z-index: 2;

        .Heziyun-banner-title {
            .btn-shine {
                color: #fff;
                background: linear-gradient(to right, #d67a00 0, #ffd0a6 10%, #949494 20%);
                background-position: 0;
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                animation: shine 3s infinite linear;
                animation-fill-mode: forwards;
                -webkit-text-size-adjust: none;
                text-decoration: none;
                white-space: nowrap;
                padding: 0 48px;
                transform: translateX(-48px);
            }

            @keyframes shine {
                0% {
                    background-position: 0;
                }

                60% {
                    background-position: 370px;
                }

                100% {
                    background-position: 370px;
                }
            }

            p {
                text-align: left;
            }

            .Heziyun-buttonArray {
                .Ui-Btn {
                    width: 140px;
                    height: 40px;
                    border: none;
                    border-radius: 10px;
                    background: linear-gradient(to right, #77530a, #ffd277, #77530a, #77530a, #ffd277, #77530a);
                    background-size: 250%;
                    background-position: left;
                    color: #ffd277;
                    position: relative;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition-duration: 1s;
                    overflow: hidden;
                }

                .Ui-Btn::before {
                    position: absolute;
                    content: "免费咨询";
                    color: #ffd277;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 97%;
                    height: 90%;
                    border-radius: 8px;
                    transition-duration: 1s;
                    background-color: rgba(0, 0, 0, 0.842);
                    background-size: 200%;
                }

                .Ui-Btn:hover {
                    background-position: right;
                    transition-duration: 1s;
                }

                .Ui-Btn:hover::before {
                    background-position: right;
                    transition-duration: 1s;
                }

                .Ui-Btn:active {
                    transform: scale(0.95);
                }
            }
        }
    }

}

// 服务优势
.Heziyun-serviceAdvantages {
    background-color: #F8F9FE;

    .Heziyun-defaultWidth {
        .Heziyun-advantage {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 0.5rem;

            .Heziyun-itemSolve {
                padding: 1.5rem;
                display: flex;
                gap: 1rem;
                border-radius: 0.5rem;
                background-color: #fff;
                overflow: hidden;
                border: 0.15rem solid transparent;
                transition: all 0.3s ease;
                -webkit-transition: all 0.3s ease;
                -moz-transition: all 0.3s ease;
                -ms-transition: all 0.3s ease;
                -o-transition: all 0.3s ease;

                .Heziyun-photo {

                    img {
                        width: 3rem;
                        height: 3rem;
                        object-fit: contain;
                    }
                }

                .Heziyun-title {

                    span {
                        color: #1a202c;
                        font-weight: bold;
                        font-size: 1.1rem;
                    }

                    p {
                        color: #4B5563;
                        font-size: 0.8rem;
                        line-height: 1.7;
                        margin-top: 1rem;
                    }
                }
            }
        }
    }
}

// 解决方案架构
.Heziyun-framework {
    background-color: #fff;

    .Heziyun-defaultWidth {
        .Heziyun-structure {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            align-items: center;
            gap: 4rem;

            .Heziyun-purePhoto {
                img {
                    width: 100%;
                    height: 100%;
                    // object-fit: cover;
                    border-radius: 1rem;
                    -webkit-border-radius: 1rem;
                    -moz-border-radius: 1rem;
                    -ms-border-radius: 1rem;
                    -o-border-radius: 1rem;
                }
            }

            .Heziyun-sketch {
                display: flex;
                flex-direction: column;
                align-items: flex-start;

                .Heziyun-titleStructure {
                    color: #000000;
                    font-weight: bold;
                    font-size: 1.7rem;
                }

                .Heziyun-describe {
                    color: #4B5563;
                    margin-top: 2rem;
                    line-height: 1.5rem;
                }

                .Heziyun-whole {
                    display: flex;
                    flex-direction: column;
                    gap: 1.3rem;
                    margin-top: 2rem;

                    .Heziyun-itemMatch {
                        display: flex;
                        align-items: center;
                        gap: 0.5rem;

                        img {
                            width: 1rem;
                            height: 1rem;
                        }

                        p {
                            color: #4B5563;
                            font-size: 0.8rem;
                        }
                    }
                }

                a {
                    display: flex;
                    background: #0066FF;
                    color: #fff;
                    padding: 0.6rem 1.5rem;
                    margin-top: 3rem;

                    &:hover {
                        background: #3886fa;
                    }
                }
            }
        }
    }
}

// 行业痛点
.Heziyun-painPoints {
    background-color: #F8F9FE;

    .Heziyun-defaultWidth {
        .Heziyun-painPoints-list {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 4rem;

            .Heziyun-item {
                display: flex;
                flex-direction: column;
                gap: 1rem;
                align-items: center;

                img {
                    width: 3rem;
                    height: 3rem;
                    object-fit: contain;
                }

                span {
                    color: #1a202c;
                    font-size: 1rem;
                }

                p {
                    line-height: 1.7;
                    color: #171717cc;
                    text-align: center;
                }
            }
        }
    }

}


@media (max-width: 768px) {

    // banner图
    .Heziyun-banners {
        background: url('../../static/img/solution/finance/mode_banner.png') no-repeat center;
        background-size: cover;
        height: 80vw;
        margin-top: 15vw;

        .Heziyun-defaultWidth {
            .Heziyun-banner-title {
                align-items: center;

                .btn-shine {
                    transform: initial;
                }

                p {
                    text-align: center;
                    width: 100%;
                }

                @keyframes shine {
                    0% {
                        background-position: 0;
                    }

                    60% {
                        background-position: 270px;
                    }

                    100% {
                        background-position: 270px;
                    }
                }
            }
        }
    }

    // 服务优势
    .Heziyun-serviceAdvantages {
        background-color: #F8F9FE;

        .Heziyun-defaultWidth {
            .Heziyun-advantage {
                grid-template-columns: repeat(1, 1fr);
                gap: 3vw;

                .Heziyun-itemSolve {
                    padding: 4vw;
                    gap: 4vw;

                    .Heziyun-photo {

                        img {
                            width: 10vw;
                            height: 10vw;
                        }
                    }

                    .Heziyun-title {

                        span {
                            font-size: 5vw;
                        }

                        p {
                            font-size: 3.5vw;
                            margin-top: 3vw;
                        }
                    }
                }
            }
        }
    }

    // 解决方案架构
    .Heziyun-framework {
        .Heziyun-defaultWidth {
            .Heziyun-structure {
                grid-template-columns: repeat(1, 1fr);
                gap: 4vw;

                .Heziyun-purePhoto {
                    img {
                        border-radius: 2vw;
                        -webkit-border-radius: 2vw;
                        -moz-border-radius: 2vw;
                        -ms-border-radius: 2vw;
                        -o-border-radius: 2vw;
                    }
                }

                .Heziyun-sketch {

                    .Heziyun-titleStructure {
                        font-size: 5vw;
                    }

                    .Heziyun-describe {
                        margin-top: 3vw;
                        line-height: 6vw;
                        font-size: 3.5vw;
                    }

                    .Heziyun-whole {
                        gap: 2vw;
                        margin-top: 4vw;

                        .Heziyun-itemMatch {
                            gap: 1vw;

                            img {
                                width: 4vw;
                                height: 4vw;
                            }

                            p {
                                font-size: 3.5vw;
                            }
                        }
                    }

                    a {
                        padding: 2vw 4vw;
                        margin-top: 4vw;
                        font-size: 4vw;
                        border-radius: 0.5vw;
                        -webkit-border-radius: 0.5vw;
                        -moz-border-radius: 0.5vw;
                        -ms-border-radius: 0.5vw;
                        -o-border-radius: 0.5vw;
                    }
                }
            }
        }
    }

    // 行业痛点
    .Heziyun-painPoints {

        .Heziyun-defaultWidth {
            .Heziyun-painPoints-list {
                grid-template-columns: repeat(1, 1fr);
                gap: 5vw;

                .Heziyun-item {
                    gap: 3vw;

                    img {
                        width: 10vw;
                        height: 10vw;
                    }

                    span {
                        font-size: 5vw;
                    }
                }
            }
        }

    }
}
</style>